import * as React from "react";
import { FC } from "react";
import { Chips } from "../chips/Chips";
import { Text } from "../layout/Text";
import { ColoredListItem } from "../list";

export type ColoredSelectedItemProps = Pick<ColoredListItem, "label" | "color"> &
    Pick<React.ComponentProps<typeof Chips>, "nonShrinkable">;

export const ColoredSelectedItem: FC<ColoredSelectedItemProps> = props => {
    const { color, label, nonShrinkable } = props;

    return (
        <Chips minWidth={48} backgroundColor={color} nonShrinkable={nonShrinkable}>
            <Text title={label}>{label}</Text>
        </Chips>
    );
};
